// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sharpness"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.5 3V18.5H4L19.5 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.4996 22L2.5 22M19.4996 3V18.5H3.99963L19.4996 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SharpnessIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sharpness',
    ref,
    icon: element,
  },
));

SharpnessIcon.displayName = 'SharpnessIcon';

export default SharpnessIcon;
